<template>
  <div class="menu-title">
    <div class="menu-title_body">
      <h1>
        <slot />
      </h1>
    </div>
    <div v-if="img" class="menu-title_img">
      <img :src="img" alt="">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    img: {
      type: String,
      default: null,
    },
  },
}
</script>

<style lang="less">
.menu-title {
  width: 100%;
  display: flex;
  align-items: center;

  &_body {
    flex-grow: 1;

    p, h1 {
      //font-family: 'Roboto Slab', Arial, sans-serif;
      font-family: 'Aqum', Arial, sans-serif;
      font-weight: 500;
      font-size: 70px;
      color: #000;
      line-height: 1.2;
      padding-top: 30px;

      @media screen and (max-width: 768px) {
        font-size: 35px;
        text-align: center;
        padding-top: 0;
      }
    }
  }

  &_img {
    width: 132px;
    height: 123px;
    background-color: #F5F5F5;
    flex-grow: 0;
    flex-shrink: 0;
    border-radius: 50%;
    position: relative;

    @media screen and (max-width: 768px) {
      display: none;
    }

    img {
      width: 160px;
      height: 100%;
      object-fit: contain;
      object-position: center;
      position: absolute;
      top: 50%;
      right: 15px;
      transform: translateY(-50%);
    }
  }
}
</style>
